import PropTypes from "prop-types";
import React from "react";
import Modal from "../../Modal";
import { Typography, Button, TextField, MenuItem, Box } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { defaultEventDurations } from "../../../constants";

const useStyles = makeStyles(theme => ({
  subtitle: {
    marginBottom: theme.spacing(3)
  },
  selectField: {
    color: theme.palette.text.secondary,
    width: 160
  }
}));

const CalendarSettingsForm = ({ onSettingsChange, values }) => {
  const classes = useStyles();

  return (
    <div>
      <Typography
        className={classes.subtitle}
        variant="h5"
        color="textSecondary"
      >
        Calendar Options
      </Typography>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
      >
        <Box mr={{ xs: 3, sm: 12 }}>
          <Typography variant="subtitle1" color="textSecondary">
            Default Event Duration
          </Typography>
        </Box>
        <TextField
          className={classes.selectField}
          select
          variant="filled"
          value={values.defaultEventDuration}
          onChange={onSettingsChange("defaultEventDuration")}
          InputProps={{
            inputProps: {
              name: "repository",
              id: "repository-filter"
            }
          }}
          SelectProps={{
            displayEmpty: true
          }}
          hiddenLabel
        >
          <MenuItem value={defaultEventDurations.halfHour}>30 minutes</MenuItem>
          <MenuItem value={defaultEventDurations.oneHour}>1 hour</MenuItem>
          <MenuItem value={defaultEventDurations.allDay}>All Day</MenuItem>
        </TextField>
      </Box>
    </div>
  );
};

const CalendarSettings = ({ onOpenChange, open, onSubmit }) => {
  const [calendarSettingsData, setCalendarSettingsData] = React.useState({
    defaultEventDuration: "30mins"
  });

  const handleCalendarSettingsDataChange = field => event => {
    setCalendarSettingsData({
      ...calendarSettingsData,
      [field]: event && event.target ? event.target.value : event
    });
  };
  return (
    <Modal
      showCloseIcon
      dialogTitle={
        <Typography variant="h4" color="textPrimary">
          Calendar Settings
        </Typography>
      }
      open={open}
      onClose={() => onOpenChange(false)}
      dialogContent={
        <CalendarSettingsForm
          onSettingsChange={handleCalendarSettingsDataChange}
          values={calendarSettingsData}
        />
      }
      dialogActions={
        <>
          <Button
            color="primary"
            onClick={() => {
              onOpenChange(false);
            }}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={() => onSubmit(calendarSettingsData)}
          >
            Save
          </Button>
        </>
      }
      maxWidth="md"
      scrollable
    />
  );
};

CalendarSettings.propTypes = {
  /**
   * True if the settings modal is open, false otherwise
   */
  open: PropTypes.bool,
  /**
   * Called when the settings modal is open or closed
   */
  onOpenChange: PropTypes.func,
  /**
   * Called when the save button is pressed to save the selected calendar settings
   */
  onSubmit: PropTypes.func
};

export default CalendarSettings;
